import React from "react";
import PauseImg from "../../../assets/img/movement/pause.svg";
import Skip from "../../../assets/img/movement/skip.svg";
import './VideoTopElement.scss';
import GLOBAL from '../../../global';
import { useTenantFeatures } from '../../../features/tenantFeatures/useTenantFeature';

const VideoTopElement = ({onClickPauseBtn, onClickSkip, selectedExercise, testId, isMovementPaused, isFullScreenVideo, isSkipping, isVideoTopElementDisabled}) => {
    const { isExamineticsEnabled } = useTenantFeatures();

    return (
        <>
            <div className={isFullScreenVideo ? "video-top-element--display-none" : "video-top-element--display-flex-margin-bottom-important"}>
                <div className="video-top-element__controls">
                    {!isExamineticsEnabled && (
                        <button type="button"
                            disabled={isSkipping || isVideoTopElementDisabled}
                            className="video-top-element__control-btn"
                            onClick={()=>onClickPauseBtn()}>
                            {isMovementPaused && (
                                <span className="video-top-element__control-btn--design">
                                    <span className='video-top-element__control-btn--design-text'>Pause</span>
                                    <img height="20" src={PauseImg} alt="Pause"/>
                                </span>
                            )}
                            {!isMovementPaused && (
                                <span className="video-top-element__control-btn--design"><span className='video-top-element__control-btn--design-text'>Pause</span>
                                    <img height="20" src={PauseImg} alt="Pause"/></span>
                            )}
                        </button>
                    )}
                    {/*<button type="button"*/}
                    {/*    disabled={!lastMovementPerformed || lastMovementPerformed === {} || isSkipping || isVideoTopElementDisabled}*/}
                    {/*        className="video-top-element__control-btn"*/}
                    {/*        onClick={() => onClickRetakeExercise(lastMovementPerformed)}*/}
                    {/*        >*/}
                    {/*    <span className="video-top-element__control-btn--design">*/}
                    {/*        <span className='video-top-element__control-btn--design-text'>Retake</span>*/}
                    {/*        <img height="20" src={Retake} alt="RetakeLast"/>*/}
                    {/*    </span>*/}
                    {/*</button>*/}
                    {selectedExercise?.IsUserCanSkip && (
                        <button type="button"
                            disabled={isSkipping || isVideoTopElementDisabled}
                            className="video-top-element__control-btn"
                            onClick={() => onClickSkip(selectedExercise)}
                        >
                            {isSkipping ? <span className="video-top-element__control-btn--design" style={{color: "#FFFFFF"}}><i className="fa fa-spinner fa-spin"/>&nbsp;Skipping...</span>
                                : <span className="video-top-element__control-btn--design"  style={{color: "#FFFFFF"}}>
                                    <span className='video-top-element__control-btn--design-text'>Unable to Perform</span>
                                    <img height="20" src={Skip} alt='Skip' />
                                </span>}
                        </button>
                    )}
                </div>
                <div className="video-top-element__test-id">
                    {testId}
                </div>
            </div>
        </>
    );
}

export default VideoTopElement;